var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"}],attrs:{"title":"Back to top","fab":"","dark":"","fixed":"","bottom":"","right":"","color":"primary"},on:{"click":_vm.toTop}},[_c('v-icon',[_vm._v("mdi mdi-chevron-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }